import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from 'parts/Header';
import Hero from 'parts/Hero';
import Highlight from 'parts/Highlight';
import Testimony from 'parts/Testimony';
import Footer from 'parts/Footer';
import { fetchPage } from 'store/actions/page';

function LandingPage(props) {
    const dispatch = useDispatch();
    const page = useSelector(state => state.page);
    const refHighlight = useRef();

    useEffect(() => {
        // Set the page title and scroll position
        document.title = "Green Hill Resort | Home";
        window.scrollTo(0, 0);

        // Fetch page data if not already available
        // if (!page.landingPage) {
        //     dispatch(fetchPage(`/landing-page`, 'landingPage'));
        // }
        if (!page.testimonials) {
            dispatch(fetchPage(`/testimonials`, 'testimonials'));
        }
    }, [dispatch, page]);

    // Show nothing until data is loaded
    if (!page.hasOwnProperty("testimonials")) return null;

    return (
        <>
            <Header {...props} />
            <Hero refHighlight={refHighlight} />
            <Highlight refHighlight={refHighlight} />
            <Testimony data={page.testimonials.testimonial} />
            <Footer />
        </>
    );
}

export default LandingPage;